import Locale from '/@/modules/user/Enum/Locale';

export const ContactUsDetails = {
  [Locale.ENGLISH.key]: {
    PRIVACY_POLICY: 'https://www.clearestate.com/privacy-policy',
    TERMS_OF_USE: 'https://www.clearestate.com/terms-of-use',
    CONTACT_EMAIL: 'hello@clearestate.com'
  },
  [Locale.FRENCH.key]: {
    PRIVACY_POLICY: 'https://www.clearestate.com/fr-ca/politique-de-confidentialit%C3%A9',
    TERMS_OF_USE: 'https://www.clearestate.com/fr-ca/conditions-dutilisation',
    CONTACT_EMAIL: 'bonjour@clearestate.com'
  }
};
